import { ReactNode } from 'react';
import { ThemeProvider as Theme } from 'styled-components';
import theme from './theme';
import GlobalStyles from './global';
import { locale } from 'devextreme/localization';

// ----------------------------------------------------------------------

import 'devextreme/dist/css/dx.light.css';
import './dx-styles.css';

// ----------------------------------------------------------------------

export * from './styles';
export * from './ui.styles';
export * from './main.styles';
export * from './auth.styles';

// ----------------------------------------------------------------------

interface Props {
  children: ReactNode;
};

// ----------------------------------------------------------------------

export default function ThemeProvider({ children }: Props) {
  locale("ko");
  
  return (
    <Theme theme={theme}>
      <GlobalStyles />
      { children }
    </Theme>
  );
}